import CityHero from './CityHero';

export default CityHero;
